import React from 'react';
import './App.css';

import { ChakraProvider } from '@chakra-ui/react';
import dayjs from 'dayjs';
import ptBr from 'dayjs/locale/pt-br';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { QueryClientProvider } from 'react-query';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import 'react-modern-calendar-datepicker/lib/DatePicker.css';

import { queryClient } from 'config/queries';
import initializer from 'initializers';
import Routes from 'routes';
import GlobalStyle from 'styles/global';
import theme from 'theme';

dayjs.extend(customParseFormat);

dayjs.locale(ptBr);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
function App() {
  initializer();

  return (
    <QueryClientProvider client={queryClient}>
      <GlobalStyle />
      <ChakraProvider theme={theme}>
        <Routes />
      </ChakraProvider>
    </QueryClientProvider>
  );
}

export default App;
